export const WHITEBOX_STRATEGY_IDS = [588];
export const CODE_PARAM = 'code';

export const WHITEBOX_MAX_STOCKS = 30;
export const WHITEBOX_MAX_CAPITAL = 2000000;
export const WHITEBOX_MIN_CAPITAL = 500;
